import { Dialog } from '../../../core/view';

export default class SelectPdfPage extends Dialog {
    title: string;

    // コールバック関数
    callBack: Function;
    pdf: any;

    set maxPages(value: number) {
      const element: HTMLElement = <HTMLElement> document.getElementById('page_list');
      let option: HTMLOptionElement;
      for (let i: number = 1; i <= value; i += 1) {
        option = new Option(`${i} ページ目`, i.toString());
        element.appendChild(option);
      }
    }

    /**
     * コンストラクタ
     */
    constructor(draggable) {
      super(draggable);

      // ダイアログのコンテンツ生成
      const id = 'SelectEsimateTypeDialog';
      const title = '取り込みページの指定';

      let contents = '<div id="selectPdfPageDialog">\n';
      contents += '<form id="formatType" class="formStyle01">';
      contents += '<div class="input_box">';
      contents += '<div class="subtitle" style="padding:10px">PDFの何ページ目を取り込みますか？</div>';
      contents += '<select class="page_list" id="page_list" name="page_list" style="display: block; margin: auto; padding:5px;">';
      contents += '</select>';
      contents += '</div>';
      contents += '</form>';
      contents += '</div>\n';
      const footer = '<button id="btnSelectPdfPage" value="true" class="btn btn_basic"><span>OK</span></button>';

      this.createDialog(id, title, contents, footer);

      // イベント設定
      (<HTMLButtonElement>document.querySelector('#btnSelectPdfPage')).addEventListener('click', this.btnEventHandler);
    }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e) => {
      e.preventDefault();

      if (e.currentTarget.value === 'true') {
        // PDF読込
        this.callBack(this.pdf, Number((<HTMLOptionElement>$('#page_list').get(0)).value));
      }

      // 閉じる
      this.close();
    }
}
